import type {UiReadinessSurface} from './ui-readiness-contract'

/**
 * Surface values reported on Datadog metrics. Hydro facts keep `UiReadinessSurface`; the
 * renamed values group metrics by experience, and embedded chat is split by open state, which
 * is only known once the view binds a session.
 */
export const METRIC_SURFACES = [
  'immersive_new',
  'immersive_chat',
  'contextual_new',
  'contextual_chat',
  'contextual_unknown',
  'explain_error',
  'repository_task',
  'repository_agents',
  'new_repository_task',
  'global_overlay',
  'dashboard',
  'chat_app',
  'issue_panel',
  'memex_panel',
  'repository_panel',
  'unknown',
] as const

export type MetricSurface = (typeof METRIC_SURFACES)[number]

/** Whether the view had a task or chat open (`chat`) or was a new chat (`new`). */
export type MetricOpenState = 'new' | 'chat' | 'unknown'

export function metricSurface(surface: UiReadinessSurface, openState: MetricOpenState): MetricSurface {
  switch (surface) {
    case 'agents_page':
      return 'immersive_new'
    case 'global_task':
      return 'immersive_chat'
    case 'embedded_chat':
      return openState === 'new' ? 'contextual_new' : openState === 'chat' ? 'contextual_chat' : 'contextual_unknown'
    default:
      return surface
  }
}

export function boundOpenState(fact: {
  readonly binding_kind?: 'new_session' | 'session'
  readonly session_id?: string
  readonly task_id?: string
}): MetricOpenState {
  if (fact.binding_kind === 'new_session') return 'new'
  if (fact.binding_kind === 'session' || fact.session_id || fact.task_id) return 'chat'
  return 'unknown'
}
